import * as React from 'react'

import {Image, Stack, Text} from '@chakra-ui/react'
import {Link} from 'react-router-dom'

import {ArrowButton} from '@/common/arrow-button'
import {HOME} from '@/router/paths'
import {USER_SUPPORT_GROUPS} from '@/user/router'

import picture from './picture.svg'

const SupportGroupOrderFulfilled = () => (
  <Stack align="center" justify="center" spacing={12}>
    <Image src={picture} />
    <Stack
      align="center"
      justify="center"
      spacing={0}
      color="brand.gray.600"
      fontSize={['20px', null, '28px']}
      lineHeight="30px"
      fontWeight={700}
      textAlign="center"
    >
      <Text>Dziękujemy za dokonanie płatności</Text>
      <Text>Dostęp do grupy wsparcia został wykupiony</Text>
    </Stack>
    <Stack direction={['column', null, 'row']} spacing={8} align="center" justify="center">
      <ArrowButton
        as={Link}
        to={HOME}
        bg="brand.green.600"
        hoverBg="brand.green.700"
        color="white"
        height={40}
        fontSize="lg"
        fontWeight={500}
        width="320px"
        flipped={true}
      >
        Powrót na stronę główną
      </ArrowButton>
      <ArrowButton
        as={Link}
        to={USER_SUPPORT_GROUPS}
        bg="brand.yellow.600"
        hoverBg="brand.yellow.700"
        color="white"
        height={40}
        fontSize="lg"
        fontWeight={500}
        width="320px"
      >
        Przejdź do grup wsparcia
      </ArrowButton>
    </Stack>
  </Stack>
)

export default SupportGroupOrderFulfilled
